export default "__VITE_PUBLIC_ASSET__a141a883__"